export class ToAccountInfo {
    accountNumber: string;
    registrationType: string;
    regTypeShortName: string;
    productCode: string;
    isIdentical: boolean; //used to determine if 1st or 3rd party account
    isRelated: boolean;
    isIraAccount: boolean;
    isTrust: boolean;
    toIncome: string;
    toPrincipal: string;
    accountRegistration: string[];
    availableCashMmf: string;
}